import { useFetch } from "matsuri-hooks"
import { useAuth } from "m2m-components/storage/useM2mAuth"
import { useAuthUser } from "@/hooks/useAuthUser"
import { incentiveTargetApiUrl } from "@/utils/urls"

interface IsIncentiveTargetOutput {
    isTarget: boolean
}

/**
 * インセンティブプログラム対象者かどうかを判定する。
 *
 * 参照先はランクダッシュボードの `/api/incentive-target/{workerId}`。
 * 従来は m2m-cleaning の `GET /v4/incentive_target_cleaners/me`
 * （MySQL の incentive_target_cleaner_records）を見ていたが、対象者の正データは
 * BigQuery の worker_incentive_config なので、そこを直接見るサービスに寄せた。
 * これにより BQ への登録・削除が最大10分で反映される（従来は日次バッチ経由で最大24h、
 * かつ削除は反映されなかった）。
 *
 * 戻り値の形は従来と互換。非対象は 200 { isTarget: false } で返るため、
 * 通信エラー（BQ 障害時の 503 を含む）では data が undefined になり導線は非表示になる。
 * これは従来 API がエラーになった場合と同じ挙動。
 */
export const useIsIncentiveTarget = () => {
    const { token } = useAuth()
    const { userId } = useAuthUser(token)
    return useFetch<IsIncentiveTargetOutput>(incentiveTargetApiUrl(userId), {
        swrConfig: { revalidateOnFocus: false }
    })
}
